import useUserData from "../../hooks/user/useUserData";
import {getAvailabilityConfig} from "./availability";

import DOMPurify from "dompurify";

export const normalizeProductKeepLang = (apiResponse) => {
    const d = apiResponse?.data;
    if (!d) return null;

    const item = d.item ?? {};
    const imagesRaw = Array.isArray(d.images) ? d.images : [];
    const colorsRaw = Array.isArray(d.colors) ? d.colors : [];
    const specsRaw = Array.isArray(d.specs) ? d.specs : [];
    const categoriesRaw = Array.isArray(d.categories) ? d.categories : [];
    const priceRaw = d.price ?? {};

    const price = {
        current: priceRaw.current ?? "",
        old: priceRaw.old ?? "",
        currency: priceRaw.currency ?? "€",
    };
    const images = [...imagesRaw]
        .sort((a, b) => Number(b?.isMain === "1") - Number(a?.isMain === "1"))
        .map((img) => ({
            id: String(img.id),
            src: img.src,
            isMain: img.isMain === "1",
            altEL: item.nameEL ?? "",
            altEN: item.nameEN ?? "",
        }));

    const colors = colorsRaw.map((c) => ({
        id: String(c.ItemId),
        itemId: String(c.ItemId),
        nameEL: c.nameEL ?? "",
        nameEN: c.nameEN ?? "",
        hex: c.hex ?? null,
    }));

    const specs = specsRaw.map((s) => ({
        id: String(s.id),
        labelEL: s.labelEL ?? "",
        labelEN: s.labelEN ?? "",
        valueEL: s.valueEL ?? "",
        valueEN: s.valueEN ?? "",
    }));

    const category = categoriesRaw[0] ?? null;
    const availabilityCode = String(item.availabilityLabel ?? "");
    const availability = getAvailabilityConfig(availabilityCode) ?? null;
    return {
        // βασικά
        id: String(item.id ?? ""),
        code: item.code ?? "",

        brandEL: item.BrandEL ?? "",
        brandEN: item.BrandEN ?? "",

        nameEL: item.nameEL ?? "",
        nameEN: item.nameEN ?? "",

        availability: availability,
        // shortDescriptionEL_html: item.shortDescriptionEL ?? "",
        // shortDescriptionEN_html: item.shortDescriptionEN ?? "",
        shortDescriptionEL: item.shortDescriptionEL,
        shortDescriptionEN: item.shortDescriptionEN,

        // descriptionEL_html: item.descriptionEL ?? "",
        // descriptionEN_html: item.descriptionEN ?? "",
        descriptionEL: item.descriptionEL,
        descriptionEN: item.descriptionEN,

        // category
        categoryEL: category?.CategoryEL ?? "",
        categoryEN: category?.CategoryEN ?? "",
        price,
        // arrays
        images,
        colors,
        specs,


        defaultColorId: colors[0]?.id ?? null,
    };
};